import { Controller } from "@hotwired/stimulus"

// Swaps a truncated preview for the full value when clicked — used for long
// identifiers shown abbreviated on the timecard detail card. One-way: once
// revealed it stays revealed.
export default class extends Controller {
  static targets = ["short", "full"]

  reveal(event) {
    event.preventDefault()
    this.shortTarget.hidden = true
    this.fullTarget.hidden = false
  }
}
